import React from "react";
import StoreItemDetailsView from "../component/StoreItemDetailsView";

const StoreItemDetailContainer = () => (<StoreItemDetailsView />)

export default StoreItemDetailContainer;
